export enum QuickFilterEnum {
  CREATED_ISSUES = 'created-issues',
  MANAGED_ISSUES = 'managed-issues',
  OWNED_ISSUES = 'owned-issues',
  OWNED_ACTIONS = 'owned-actions',
  TO_BE_APPROVED = 'to-be-approved',
}

export enum CreatedIssuesTypeEnum {
  ALL = 'all',
  DRAFT = 'draft',
  IN_REVIEW = 'open', // Backend field name remains 'open'
  IN_PROGRESS = 'in-progress',
  REMEDIATION_PLANNING = 'remediation-planning',
  IN_REMEDIATION = 'in-remediation',
  TO_BE_PUBLISHED = 'to-be-published',
  PENDING_ACCEPTANCE = 'pending-acceptance',
}

export enum ManagedIssuesTypeEnum {
  ALL = 'all',
  IN_REVIEW = 'in-review',
  OVERDUE = 'overdue',
  SLA_OVERDUE = 'sla-overdue',
}

export enum OwnedIssuesTypeEnum {
  ALL = 'all',
  OVERDUE = 'overdue',
  TO_BE_APPROVED = 'to-be-approved',
}

export enum OwnedActionsTypeEnum {
  ALL = 'all',
  OPEN = 'open',
  IN_PROGRESS = 'in-progress',
  OVERDUE = 'overdue',
  TO_BE_APPROVED = 'to-be-approved',
  COMPLETED = 'completed',
}

export enum ToBeApprovedTypeEnum {
  ISSUES_TO_APPROVE = 'issues-to-approve',
  ACTIONS_TO_APPROVE = 'actions-to-approve',
}
